import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingTableRow } from '../../utils/styles';
export default function LoadingTableState({
  columns
}) {
  return /*#__PURE__*/_jsx("tr", {
    children: Array.from(Array(columns).keys()).map(c => /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(LoadingTableRow, {})
    }, c))
  });
}